import {
  MKBorderStyle,
  MKLineStyle,
  MKMarkup,
  MKPoint,
  MKSpan,
} from '@bluebeam/markupkit-web';

// Would be nice to get the types directly from MarkupKit.
export type MKrenderMarkup = (_arg0: any, _arg1: any, _arg2: any) => void;

interface ContructorArgs {
  MKMarkup: typeof MKMarkup;
  MKPoint: typeof MKPoint;
  MKSpan: typeof MKSpan;
  MKLineStyle: typeof MKLineStyle;
  MKBorderStyle: typeof MKBorderStyle;
  mkRenderMarkup: MKrenderMarkup;
}

class MarkupKit {
  MKMarkup: typeof MKMarkup;

  MKPoint: typeof MKPoint;

  MKSpan: typeof MKSpan;

  MKLineStyle: typeof MKLineStyle;

  MKBorderStyle: typeof MKBorderStyle;

  mkRenderMarkup: MKrenderMarkup;

  constructor(args: ContructorArgs) {
    this.MKMarkup = args.MKMarkup;
    this.MKPoint = args.MKPoint;
    this.MKSpan = args.MKSpan;
    this.MKLineStyle = args.MKLineStyle;
    this.MKBorderStyle = args.MKBorderStyle;
    this.mkRenderMarkup = args.mkRenderMarkup;
  }
}

export async function getMarkupKitComponent(): Promise<MarkupKit> {
  const MK = await import('@bluebeam/markupkit-web');

  return new MarkupKit({
    MKMarkup: MK.MKMarkup,
    MKPoint: MK.MKPoint,
    MKSpan: MK.MKSpan,
    MKLineStyle: MK.MKLineStyle,
    MKBorderStyle: MK.MKBorderStyle,
    mkRenderMarkup: MK.renderMarkup,
  });
}

export default MarkupKit;
